import { EventTypes } from '@candulabs/craft';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectCollectionItemEvents } from 'craft/state/collections/selectors';

import useSelection from './useSelection/useSelection';

export const useSelectionClassName = (
  id: string,
  collectionItemId?: string,
  isCollectionRoot?: boolean,
) => {
  const collectionSelectedItemId = useSelector(selectCollectionItemEvents)[EventTypes.selected];

  const {
    selection: { all },
  } = useSelection();

  return useMemo(() => {
    // is not within a collection
    if (!collectionItemId && !isCollectionRoot) {
      return all.includes(id) ? `selected` : ``;
    }

    // is within a collection, and specifically selecting the very node
    if (collectionItemId === collectionSelectedItemId) {
      return all.includes(id) ? `selected--collection` : `collection`;
    }

    // is within a collection default
    return 'collection';
  }, [collectionSelectedItemId, collectionItemId, all, id, isCollectionRoot]);
};
